import { render, staticRenderFns } from "./DutyInfo.vue?vue&type=template&id=fc385b6e&scoped=true&"
import script from "./DutyInfo.vue?vue&type=script&lang=ts&"
export * from "./DutyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc385b6e",
  null
  
)

export default component.exports